import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function Footer() {
  const { t } = useTranslation();

  const footerCategories = [
    { label: "Shoes", href: "https://kaspreadsheet.com/category-911-Shoes.html" },
    { label: "Hoodies/Sweaters", href: "https://kaspreadsheet.com/search-912/name/Shoes.html" },
    { label: "T-Shirts", href: "https://kaspreadsheet.com/search-913/name/Shoes.html" },
    { label: "Jackets", href: "https://kaspreadsheet.com/search-914/name/Shoes.html" },
  ];

  const footerGuides = [
    { label: t("footer.guide_beginner"), to: "/artykul/kakobuy-jak-zaczac" },
    { label: t("footer.guide_shipping"), to: "/artykul/kakobuy-wysylka-polska" },
    { label: t("footer.guide_safety"), to: "/artykul/kakobuy-bezpieczenstwo-zakupow" },
    { label: t("footer.guide_qc"), to: "/artykul/kakobuy-qc-zdjecia" },
  ];

  const footerTools = [
    { label: t("footer.tool_search"), to: "/artykul/kakobuy-najlepsze-finds" },
    { label: t("footer.tool_finder"), to: "/artykul/kakobuy-sneakers-spreadsheet" },
    { label: t("footer.tool_compare"), to: "/artykul/kakobuy-streetwear-spreadsheet" },
    { label: t("footer.tool_haul"), to: "/artykul/kakobuy-spreadsheet-aktualizacja" },
  ];

  const footerLegal = [
    { label: t("footer.privacy"), to: "/" },
    { label: t("footer.terms"), to: "/" },
    { label: t("footer.disclaimer"), to: "/" },
    { label: t("footer.security"), to: "/artykul/kakobuy-bezpieczenstwo-zakupow" },
  ];

  return (
    <footer className="bg-background-100">
      <div className="w-full px-6 md:px-10 py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4">
              {t("footer.categories")}
            </h4>
            <div className="w-8 h-px bg-background-300 mb-4"></div>
            <ul className="space-y-2.5">
              {footerCategories.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors duration-200 cursor-pointer"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4">
              {t("footer.guides")}
            </h4>
            <div className="w-8 h-px bg-background-300 mb-4"></div>
            <ul className="space-y-2.5">
              {footerGuides.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.to}
                    className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors duration-200 cursor-pointer"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4">
              {t("footer.tools")}
            </h4>
            <div className="w-8 h-px bg-background-300 mb-4"></div>
            <ul className="space-y-2.5">
              {footerTools.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.to}
                    className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors duration-200 cursor-pointer"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4">
              {t("footer.legal")}
            </h4>
            <div className="w-8 h-px bg-background-300 mb-4"></div>
            <ul className="space-y-2.5">
              {footerLegal.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.to}
                    className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors duration-200 cursor-pointer"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

        </div>

        <div className="mt-16 flex flex-col md:flex-row items-start md:items-end justify-between gap-6">
          <div>
            <div className="flex items-baseline gap-1">
              <span className="text-4xl font-black text-foreground-900 tracking-tight">Kakobuy</span>
              <span className="text-4xl font-black text-foreground-300 tracking-tight">Finds</span>
            </div>
            <div className="w-12 h-px bg-background-300 my-3"></div>
            <p className="text-xs text-foreground-500">{t("site.tagline")}</p>
          </div>
          <div className="flex flex-col md:items-end gap-2">
            <p className="text-xs text-foreground-500">{t("footer.copyright")}</p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-200 text-foreground-600 hover:text-foreground-900 transition-colors duration-200 cursor-pointer">
                <i className="ri-facebook-fill text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-200 text-foreground-600 hover:text-foreground-900 transition-colors duration-200 cursor-pointer">
                <i className="ri-instagram-line text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-200 text-foreground-600 hover:text-foreground-900 transition-colors duration-200 cursor-pointer">
                <i className="ri-twitter-x-line text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-200 text-foreground-600 hover:text-foreground-900 transition-colors duration-200 cursor-pointer">
                <i className="ri-pinterest-line text-sm"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}